import { CriterionToAttributeMap } from "@Evaluation/AlternativesSurveys/types"

export function buildMeetingManagerPageQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.MeetingManagerPageQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId,
	}
}

export function buildPanelistMeetingPageQueryV1(workspaceId: number, surveyId: number, projectUserId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.PanelistMeetingPageQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
		'ProjectUserId': projectUserId,
	}
}

export function buildPanelistSurveyDashboardPageQueryV1(workspaceId: number, surveyId: number, projectUserId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.PanelistSurveyDashboardPageQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
		'ProjectUserId': projectUserId,
	}
}

export function buildPanelistSurveyAlternativePageQueryV1(workspaceId: number, surveyId: number, projectUserId: number, alternativeId: string)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.PanelistSurveyAlternativePageQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
		'ProjectUserId': projectUserId,
		'AlternativeId': alternativeId,
	}
}

export function buildPanelistSurveyCriterionPageQueryV1(workspaceId: number, surveyId: number, projectUserId: number, criterionId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.PanelistSurveyCriterionPageQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
		'ProjectUserId': projectUserId,
		'CriterionId': criterionId,
	}
}

export function buildScoringPanelistsPageQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.ScoringPanelistsPageQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId,
	}
}

export function buildScoringSurveysPageQueryV1(workspaceId: number, projectId: number, evalModelId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.ScoringSurveysPageQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvaluationModelId': evalModelId,
	}
}


export function buildScoringSurveyQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.ScoringSurveyQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId,
	}
}



export function buildPanelAlternativesManagerQueryV1(surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.PanelAlternativesManagerQueryV1, TCh.Domain.Evaluation',
		'SurveyId': surveyId,
	}
}

export function buildSurveyAlternativeViewQueryV1(surveyId: number, votesSourceId: number, evalAlternativeId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.SurveyAlternativeViewQueryV1, TCh.Domain.Evaluation',
		'SurveyId': surveyId,
		'VotesSourceId': votesSourceId,
		'EvalAlternativeId': evalAlternativeId,
	}
}

export function buildSurveyCriterionViewQueryV1(surveyId: number, votesSourceId: number, evalCriterionId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.SurveyCriterionViewQueryV1, TCh.Domain.Evaluation',
		'SurveyId': surveyId,
		'VotesSourceId': votesSourceId,
		'EvalCriterionId': evalCriterionId,
	}
}

export function buildSurveyDashboardQueryV1(surveyId: number, votesSourceId: number, isWorkspaceUser: boolean)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.SurveyDashboardQueryV1, TCh.Domain.Evaluation',
		'SurveyId': surveyId,
		'VotesSourceId': votesSourceId,
		'IsWorkspaceUser': isWorkspaceUser,
	}
}


export function buildScoringPanelistsManagerQueryV1(workspaceId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.ScoringPanelistsManagerQueryV1, TCh.Domain.Evaluation',
		'SurveyId': surveyId,
		'WorkspaceId': workspaceId
	}
}

export function buildScoringPanelistQueryV1(workspaceId: number, surveyId: number, projectUserId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.ScoringPanelistQueryV1, TCh.Domain.Evaluation',
		'SurveyId': surveyId,
		'WorkspaceId': workspaceId,
		'ProjectUserId': projectUserId
	}
}

export function buildScoringAccessLinksBySurveyIdQueryV1(workspaceId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.ScoringAccessLinksBySurveyIdQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
	}
}


export function buildExportScoringAccessLinksBySurveyIdQueryV1(workspaceId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.ExportScoringAccessLinksBySurveyIdQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'SurveyId': surveyId,
	}
}

export function buildScoresExporterQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.ScoresExporterQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId,
	}
}

export function buildScoresExporterPreviewQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, mappings: CriterionToAttributeMap[])
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.ScoresExporterPreviewQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId,
		'Mappings': mappings
	}
}

export function buildSubSurveysManagerQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.SubSurveysManagerQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'MasterSurveyId': surveyId,
	}
}

export function buildSurveyCriteriaManagerQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.SurveyCriteriaManagerQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId,
	}
}

export function buildSurveyAlternativesManagerQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.SurveyAlternativesManagerQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId,
	}
}


export function buildFilterAlternativesByListQueryV1(workspaceId: number, projectId: number, evalModelId: number, alternativesListId: number, viewDefId: string)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.FilterAlternativesByListQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'AlternativesListId': alternativesListId,
		'ViewDefId': viewDefId
	}
}

export function buildAlternativeDescriptionQueryV1(workspaceId: number, projectId: number, evalModelId: number, alternativesListId: number, alternativeId: string, descriptionTemplate: string)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.AlternativeDescriptionQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'AlternativesListId': alternativesListId,
		'AlternativeId': alternativeId,
		'DescriptionTemplate': descriptionTemplate,
	}
}

export function buildPanelDisagreementsQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.PanelDisagreementsQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId,
	}
}

export function buildPanelConsistencyAnalysisQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.PanelConsistencyAnalysisQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId,
	}
}

export function buildPanelistConsistencyAnalysisQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, projectUserId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.PanelistConsistencyAnalysisQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId,
		'ProjectUserId': projectUserId,
	}
}

export function buildMeetingQuestionReviewQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, questionId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.MeetingQuestionReviewQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'EvalModelId': evalModelId,
		'SurveyId': surveyId,
		'QuestionId': questionId
	}
}



export function buildPanelistVoteQueryV1(workspaceId: number, projectUserId: number, questionId: number)
{
	return {
		'$type': 'TCh.Domain.Evaluation.AlternativesSurveys.Queries.PanelistVoteQueryV1, TCh.Domain.Evaluation',
		'WorkspaceId': workspaceId,
		'ProjectUserId': projectUserId,
		'QuestionId': questionId
	}
}


